export const formatDireccion = (user = {}) => {
  // @ts-expect-error TS(2339): Property 'direccion' does not exist on type '{}'.
  const direccion = user?.direccion ? `${user?.direccion},` : ""
  // @ts-expect-error TS(2339): Property 'cp' does not exist on type '{}'.
  const cp = user?.cp || ""
  // @ts-expect-error TS(2339): Property 'poblacion' does not exist on type '{}'.
  const poblacion = user?.poblacion ? `- ${user?.poblacion}` : ""
  // @ts-expect-error TS(2339): Property 'provincia' does not exist on type '{}'.
  const provincia = user?.provincia ? `(${user?.provincia})` : ""

  // @ts-expect-error TS(2339): Property 'poblacionExtranjera' does not exist on t...
  if (user.poblacionExtranjera && !user.poblacionId) {
    // @ts-expect-error TS(2339): Property 'poblacionExtranjera' does not exist on t...
    return `${direccion} ${cp} - ${user.poblacionExtranjera}`
  }

  // @ts-expect-error TS(2339): Property 'calle' does not exist on type '{}'.
  return `${user?.calle || direccion} ${cp} ${poblacion} ${provincia}`
}
